
import axios from "axios";

export default {
    getInfo(obj, token) {
        return axios.post("/course/Sale/getInfo", obj, { cancelToken: token });
    },
    getPriceConfig() {
        return axios.get("/course/Sale/getPriceConfig");
    },
    ifFirstTime() {
        return axios.get("/c/User/ifFirstTime");
    },
    tiyan() {
        return axios.get("/c/User/tiyan");
    },
    getOrderById(obj) {
        return axios.post("/course/Sale/getOrderById", obj);
    },
    getMyAddress() {
        return axios.get("/course/Usercenter/getMyAddress");
    },
    getPrize(obj) {
        return axios.post("/course/Activity/getPrize", obj);
    }
}
